import axiosInstance from "./axios";

export class SalonService {
    getSalones() {
        return axiosInstance
            .get("/salon")
            .then((res) => res.data)
    }

    addSalon(dto) {
        return axiosInstance
            .post("/salon", dto)
            .then((res) => res.data)
    }

    updateSalon(dto) {
        return axiosInstance
            .put(`/salon/${dto._id}`, dto)
            .then((res) => res.data)
    }

    deleteSalon(id) {
        return axiosInstance
            .delete(`/salon/${id}`)
            .then((res) => res.data)
    }
}
